module.exports = __webpack_public_path__ + "static/media/BB.2dbef5e1.jpg";